export default __webpack_public_path__ + "static/media/BB_31.3b4fe02a.png";